
  <template><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#10b981" fill-rule="evenodd" d="M12.74 3.38a1.347 1.347 0 0 1 1.875 0l-.001.001a1.28 1.28 0 0 1-.002 1.833L7.046 12.62a1.347 1.347 0 0 1-1.875 0L1.388 8.918a1.28 1.28 0 0 1 0-1.834 1.346 1.346 0 0 1 1.874 0l2.847 2.784z" clip-rule="evenodd"/><path fill="#10b981" d="M14.547 14.871h.919v1.13H12.1v-1.13h1.053v-2.685l-.364.304-.007.006a.536.536 0 0 1-.424.109l-.011-.002a.6.6 0 0 1-.166-.068l-.01-.005a.5.5 0 0 1-.115-.106l-.003-.004-.318-.428-.108-.146.139-.117 1.632-1.382.054-.047h1.094z"/></svg></template>
  <style scoped>
    svg {
      display: inline-block;
      vertical-align: baseline;
      margin-bottom: -2px;
    }
  </style>